export default {
  "category.title": "视频分类",
  "category.desc": "浏览不同分类的精彩视频内容，发现你的兴趣所在",
  "category.all": "全部",
  "category.videoCount": "个视频",
  "category.noVideos": "暂无视频内容",
  "category.loadMore": "加载更多",
};